import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'app/shared/api/microservices';

const baseUrl = `${process.env.RAG_SERVER_URL || 'http://localhost'}${process.env.RAG_SERVER_PORT && process.env.RAG_SERVER_PORT !== '' ? `:${process.env.RAG_SERVER_PORT}` : ''}`;

const staggeredBaseQuery = retry(
  axiosBaseQuery({
    baseUrl,
  }),
  {
    maxRetries: 0,
  },
);

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptyRagServerServicesApi = createApi({
  reducerPath: 'emptyRagServerServicesApi',
  baseQuery: staggeredBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'ALL_COLLECTIONS',
    'ALL_CHATPROFILES',
    'ALL_SOURCES',
    'ALL_DOCUMENTS',
    'ALL_MODEL_PROVIDERS',
    'ALL_PIPELINES',
  ],
});
